export default __webpack_public_path__ + "static/media/lifeline.1679fba2.png";